import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { Subscription } from 'rxjs/Subscription';
import Swal from 'sweetalert2';
import { Person } from '../../models/person';
import { FunctionService } from '../../services/function.service';
import { LogService } from '../../services/shared/log.service';
import { NGaugeService } from '../../services/shared/ngauge.service';
import { PubSubService } from '../../services/shared/pub-sub.service';
import { UserService } from '../../services/user.service';
import { ADD_PAGE, EDIT_PAGE, FUNCTION_SALES_ACTIVITY, FUNCTION_SALES_ACTIVITY_IN_DB, LOG_LEVELS, LOG_MESSAGES, PHONE_MASK_PATTERN, TEXT_AREA_TOOL_TIP } from '../../util/constants';
import { DateUtil } from '../../util/dateUtil';

@Component({
  selector: 'app-function-sales-activity-dialog',
  templateUrl: './function-sales-activity-dialog.component.html'
})

export class FunctionSalesActivityDialogComponent implements OnInit, OnDestroy {

  viewMode: any;
  funcSalesActivityForm: FormGroup;
  accountName: any;
  contacts = [];
  isLoading = true;
  phoneMask = PHONE_MASK_PATTERN;
  accountStatus = true;
  textToolTip = TEXT_AREA_TOOL_TIP;

  salesAcitivtyTypes = FUNCTION_SALES_ACTIVITY;
  salesAcitivtyTypesInDb = FUNCTION_SALES_ACTIVITY_IN_DB;
  salesPersons: any;
  traceType: string;
  updateFunctionSASubscription: Subscription;
  updateFunctionSubscription: Subscription;
  filteredContact: ReplaySubject<string[]> = new ReplaySubject<string[]>(1);
  contactFilterCtrl: FormControl = new FormControl();
  filteredSalesPerson: ReplaySubject<Person[]> = new ReplaySubject<Person[]>(1);
  spFilterCtrl: FormControl = new FormControl();
  authorizedUser = true;
  createFuncSASubscription: Subscription;
  emailPlaceHolder = 'Email';
  getusernameSubscription: Subscription;
  inValidMobile: boolean;
  inValidMail: boolean;

  constructor(
    public dialogRef: MatDialogRef<FunctionSalesActivityDialogComponent>,
    private userService: UserService,
    private functionService: FunctionService,
    private logService: LogService,
    private pubsubService: PubSubService,
    private formBuilder: FormBuilder,
    private ngaugeService: NGaugeService,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.contacts = this.data['contacts'];
    this.salesPersons = JSON.parse(JSON.stringify(this.data['salesPersons']));
    this.accountName = this.data['accountName'];
    this.authorizedUser = this.data['authority'];
    const salesData = this.data['salesActivity'];
    this.accountStatus = this.data['status'];
    this.ngaugeService.buildFilter(this.contactFilterCtrl, this.filteredContact, this.contacts, 'userName');
    this.ngaugeService.buildFilter(this.spFilterCtrl, this.filteredSalesPerson, this.salesPersons, 'userName');
    this.viewMode = salesData['id'] === undefined ? ADD_PAGE : EDIT_PAGE;
    this.buildFunctionSalesActivity();
    this.viewMode === EDIT_PAGE ? this.populateValues(salesData) : this.isLoading = false;
  }

  buildFunctionSalesActivity() {
    this.funcSalesActivityForm = this.formBuilder.group({
      account: [this.accountName],
      functionName: [this.data.salesActivity.functionName],
      typeOfSalesActivity: ['', Validators.required],
      salesActivityDate: ['', Validators.required],
      contact: [''],
      phoneNumber: [''],
      salesPerson: [this.userService.getLoggedInUserName()],
      email: [''],
      completed: [false],
      completionDate: [''],
      result: ['']
    });
  }

  async populateValues(salesData) {
    await this.checkForOldSalesPerson(salesData);
    if (!this.salesAcitivtyTypesInDb.includes(salesData['typeOfSalesActivity'])) {
      this.salesAcitivtyTypes.push(salesData['typeOfSalesActivity']);
    }
    this.salesAcitivtyTypes = this.ngaugeService.removeDuplicatesArrOfString(this.salesAcitivtyTypes);
    const findSalesActivityType = this.salesAcitivtyTypesInDb.find(type => type === salesData['typeOfSalesActivity']);
    if (findSalesActivityType) {
      const findIndex = this.salesAcitivtyTypesInDb.findIndex(type => type === salesData['typeOfSalesActivity']);
      salesData['typeOfSalesActivity'] = this.salesAcitivtyTypes[findIndex];
    }
    salesData['salesActivityDate'] = DateUtil.getNewDate(DateUtil.getValidTimeZone(salesData['salesActivityDate']));
    const filteredSalesActivity = this.salesPersons.filter(salesPerson => salesPerson['id'] === salesData['salesPerson']);
    salesData['salesPerson'] = filteredSalesActivity.length > 0 ? filteredSalesActivity[0]['userName'] : salesData['salesPerson'];
    const filteredContact = this.contacts.filter(contact => contact['id'] === salesData['contact']);
    salesData['contact'] = filteredContact.length > 0 ? filteredContact[0]['userName'] : salesData['contact'];
    this.changeContact(salesData['contact']);
    salesData['account'] = this.accountName;
    this.funcSalesActivityForm.patchValue(salesData);
    this.isLoading = false;
  }

  checkForOldSalesPerson(salesData) {
    return new Promise(async resolve => {
      const assignedPerson = this.salesPersons.filter(assignee => assignee['id'] === salesData['salesPerson']);
      if (assignedPerson.length === 0) {
        this.getusernameSubscription =
          this.userService.getUserNamebyId(salesData.salesPerson).subscribe(res => {
            const userName = res[0]['firstName'] !== undefined ? `${res[0]['firstName']} ${res[0]['lastName']}` : '';
            const user2 = this.ngaugeService.getInvalidUser(userName);
            this.salesPersons.push(user2);
            salesData.salesPerson = user2['id'];
            console.log('Old User Found');
            this.ngaugeService.buildFilter(this.spFilterCtrl, this.filteredSalesPerson, this.salesPersons, 'userName');
            resolve(true);
          }, error => {
            this.logService.logError(LOG_LEVELS.ERROR, 'Group Sales Activity Page', 'On Fetch Users', JSON.stringify(error));
          });
      } else {
        resolve(true);
      }
    });
  }

  async changeContact(contactName) {
    const filteredContact = await this.userService.populateContactDetails(contactName, this.contacts);
    const email = filteredContact['email'] !== '' ? filteredContact['email'] : filteredContact['workEmail'];
    this.emailPlaceHolder = filteredContact['email'] !== '' ? 'Email' : 'Work Email';
    this.funcSalesActivityForm.get('email').setValue(email);
    this.funcSalesActivityForm.get('phoneNumber').setValue(filteredContact['preferredContact']);
    this.checkMail(email);
    this.checkNumber(filteredContact['preferredContact']);
  }

  completionChecked(checked) {
    if (checked) {
      this.completionDate.setValidators(Validators.required);
      this.completionDate.setValue(new Date());
      this.result.setValidators([Validators.required, Validators.maxLength(10000)]);
    } else {
      this.completionDate.clearValidators();
      this.result.clearValidators();
    }
    this.completionDate.updateValueAndValidity();
    this.result.updateValueAndValidity();
  }

  get completionDate() {
    return this.funcSalesActivityForm.get('completionDate') as FormControl;
  }

  get result() {
    return this.funcSalesActivityForm.get('result') as FormControl;
  }

  addFunctionSalesActivity(formValues) {
    const filteredSalesPerson =
      this.salesPersons.filter(salesPerson => salesPerson['userName'] === formValues['salesPerson']);
    if (filteredSalesPerson[0]['id'] === 0) {
      this.funcSalesActivityForm.get('salesPerson').setValue('');
      this.ngaugeService.toastrError('In-Active Sales Person found');
      return;
    } else {
      formValues['accountId'] = this.data.accountId;
      formValues['functionId'] = this.data.functionId;
      if (this.viewMode === EDIT_PAGE) {
        formValues['id'] = this.data['salesActivity']['id'];
        const swalObject = {
          title: '<strong>Are you sure</strong>',
          text: 'Do you want to update it',
          confirmButtonText: 'Yes, Update it!',
          cancelButtonText: 'No'
        };
        const areYouSure = this.ngaugeService.swalOkCancelButton(swalObject);
        Swal(areYouSure).then((result) => {
          if (result.value) {
            formValues = this.validateFormValues(formValues);
            formValues['salesActivityDate'] = DateUtil.getFormattedDate(formValues['salesActivityDate']);
            this.updateFunctionSASubscription = this.functionService.updateFunctionsalesActivity(formValues).
              subscribe(response => {
                if (response['result'] !== false) {
                  formValues['typeOfSalesActivity'] = formValues['typeOfSalesActivity'] === 'BEODue' ?
                    'beoDue' : formValues['typeOfSalesActivity'];
                  const dataSave = { functionId: formValues['functionId'] };
                  dataSave[formValues['typeOfSalesActivity']] = formValues['salesActivityDate'];
                  this.updateFunctionSubscription = this.functionService.updateFunctionActivity(dataSave).
                    subscribe(() => {
                      this.pubsubService.publish('function-sales-activity-modified-event');
                      const findSalesActivityType = this.salesAcitivtyTypesInDb.find(type => type === formValues['typeOfSalesActivity']);
                      if (findSalesActivityType) {
                        const findIndex = this.salesAcitivtyTypesInDb.findIndex(type => type === formValues['typeOfSalesActivity']);
                        formValues['typeOfSalesActivity'] = this.salesAcitivtyTypes[findIndex];
                      }
                      this.logUserActivity('Function - Sales Activities - Edit', formValues.typeOfSalesActivity);
                      this.logUserActivity('Function - Sales Activities - Edit', LOG_MESSAGES.SAVE);
                      this.closeFunction();
                      this.ngaugeService.toastrSuccess(`Function Sales Activity updated`);
                    }, error => {
                      this.logService.logError(LOG_LEVELS.ERROR, 'Function  Sales Activity Page', 'On Update Function',
                        JSON.stringify(error));
                    });
                } else {
                  this.ngaugeService.toastrError(`Function Sales Activity update failed`);
                  this.logService.logError(LOG_LEVELS.DEBUG, 'Function  Sales Activity Page', 'On Update Function',
                    JSON.stringify(formValues));
                }
              }, error => {
                this.logService.logError(LOG_LEVELS.ERROR, 'Function Sales Activity Page', 'On Update Function Sales Activity',
                  JSON.stringify(error));
              });
          } else {
            this.dialogRef.close();
          }
        });
      } else {
        const swalObject = {
          title: '<strong>Are you sure</strong>',
          text: 'Do you want to create it',
          confirmButtonText: 'Yes, Create it!',
          cancelButtonText: 'No'
        };
        const areYouSure = this.ngaugeService.swalOkCancelButton(swalObject);
        Swal(areYouSure).then((result) => {
          if (result.value) {
            formValues = this.validateFormValues(formValues);
            formValues['salesActivityDate'] = DateUtil.getFormattedDate(formValues['salesActivityDate']);
            this.createFuncSASubscription = this.functionService.createFunctionsalesActivity(formValues).subscribe(() => {
              this.pubsubService.publish('function-sales-activity-modified-event');
              this.ngaugeService.toastrSuccess('Function Sales Activity created');
              this.logUserActivity('Function - Sales Activities - Add', formValues.typeOfSalesActivity);
              this.logUserActivity('Function - Sales Activities - Add', LOG_MESSAGES.SAVE);
              this.closeFunction();
            }, error => {
              this.logService.logError(LOG_LEVELS.ERROR, 'Function Sales Activity Page', 'On Add Function Sales Activity',
                JSON.stringify(error));
            });
          } else {
            this.dialogRef.close();
          }
        });
      }
    }
  }

  validateFormValues(formValues) {
    const findTypeInDb = FUNCTION_SALES_ACTIVITY.find(type => type === formValues['typeOfSalesActivity']);
    if (findTypeInDb) {
      const findIndexInDb = FUNCTION_SALES_ACTIVITY.findIndex(type => type === formValues['typeOfSalesActivity']);
      formValues['typeOfSalesActivity'] = FUNCTION_SALES_ACTIVITY_IN_DB[findIndexInDb];
    }
    const filteredSalesActivity = this.salesPersons.filter(salesPerson => salesPerson['userName'] === formValues['salesPerson']);
    formValues['salesPerson'] = filteredSalesActivity.length > 0 ? filteredSalesActivity[0]['id'] : formValues['salesPerson'];
    const filteredContact = this.contacts.filter(contact => contact['userName'] === formValues['contact']);
    formValues['contact'] = filteredContact.length > 0 ? filteredContact[0]['id'] : formValues['contact'];
    return formValues;
  }

  blockAlpha(event) {
    this.ngaugeService._keyPress(event);
  }

  pasteClipboardContent(formGroup, formField) {
    let preValue = this[formGroup].get(formField).value;
    preValue = preValue === null ? '' : preValue;
    this.ngaugeService.getClipboardContent().then(text => {
      this[formGroup].get(formField).patchValue(preValue + text);
    });
  }

  openOutlook(mailId) {
    this.ngaugeService.openOutlookMail(mailId);
  }

  closeFunction() {
    const routePath = this.ngaugeService.getCurrentUrl();
    if (routePath.includes('Function')) {
      this.pubsubService.publish('function-sales-activity-modified-event');
      const action = this.viewMode === EDIT_PAGE ? EDIT_PAGE : ADD_PAGE;
      this.logUserActivity('Function - Sales Activities - ' + action, LOG_MESSAGES.CANCEL);
    } else {
      this.pubsubService.publish('appointment-modified-event');
    }
    this.dialogRef.close();
  }

  logUserActivity(from, value) {
    this.logService.logUserActivity(LOG_LEVELS.INFO, from, value);
  }

  checkNumber(mNumber) {
    this.inValidMobile = this.ngaugeService.checkForMobile(mNumber);
  }

  checkMail(mailId) {
    this.inValidMail = this.ngaugeService.checkForMail(mailId);
  }

  ngOnDestroy() {
    this.unSubscribe(this.updateFunctionSASubscription);
    this.unSubscribe(this.updateFunctionSubscription);
    this.unSubscribe(this.createFuncSASubscription);
    this.unSubscribe(this.getusernameSubscription);
    this.viewMode = null;
    this.funcSalesActivityForm = null;
    this.accountName = null;
    this.contacts = null;
    this.isLoading = null;
    this.phoneMask = null;
    this.accountStatus = null;
    this.textToolTip = null;
    this.salesAcitivtyTypes = null;
    this.salesAcitivtyTypesInDb = null;
    this.salesPersons = null;
    this.traceType = null;
    this.filteredContact = null;
    this.contactFilterCtrl = null;
    this.filteredSalesPerson = null;
    this.spFilterCtrl = null;
    this.authorizedUser = null;
    this.dialogRef = null;
    this.userService = null;
    this.functionService = null;
    this.logService = null;
    this.pubsubService = null;
    this.formBuilder = null;
    this.ngaugeService = null;
    this.data = null;
    this.emailPlaceHolder = null;
    this.inValidMobile = null;
    this.inValidMail = null;
  }

  unSubscribe(subscription: Subscription) {
    if (this.ngaugeService.checkForNllUndef(subscription)) {
      subscription.unsubscribe();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/accountFunction/function-sales-activity/function-sales-activity-dialog.component.ts